import { apiClient } from './ApiClient';

export const fetchSettings = (token) => {
  return apiClient.get(`/rest/account/settings`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

export const updateSettings = (token, updatedSettings) => {
  return apiClient.post(`/rest/account/settings`, updatedSettings, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
